export const siteConfig = {
  apiURL: import.meta.env.VITE_ENV_API_URL || 'http://localhost:8000',
  appName: import.meta.env.VITE_ENV_APP_NAME || 'Streamlyne Self-Service',
  environment: import.meta.env.VITE_ENV_ENVIRONMENT || 'development',
  enableDevAuth: import.meta.env.VITE_ENV_ENABLE_DEV_AUTH === 'true',
};
